
import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface User {
  id: string;
  phone: string;
  name: string;
  isGuest: boolean;
}

interface AuthContextType {
  user: User | null;
  isGuest: boolean;
  login: (phone: string, password: string) => Promise<boolean>;
  loginAsGuest: () => void;
  logout: () => void;
  register: (phone: string, password: string, name: string) => Promise<boolean>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isGuest, setIsGuest] = useState(false);

  useEffect(() => {
    const savedUser = localStorage.getItem('alomran_user');
    const savedGuest = localStorage.getItem('alomran_guest');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    } else if (savedGuest === 'true') {
      setIsGuest(true);
    }
  }, []);

  const login = async (phone: string, _password: string): Promise<boolean> => {
    const newUser: User = {
      id: Date.now().toString(),
      phone,
      name: 'مستخدم العمران',
      isGuest: false,
    };
    setUser(newUser);
    setIsGuest(false);
    localStorage.setItem('alomran_user', JSON.stringify(newUser));
    localStorage.removeItem('alomran_guest');
    return true;
  };

  const loginAsGuest = () => {
    setIsGuest(true);
    setUser(null);
    localStorage.setItem('alomran_guest', 'true');
    localStorage.removeItem('alomran_user');
  };

  const logout = () => {
    setUser(null);
    setIsGuest(false);
    localStorage.removeItem('alomran_user');
    localStorage.removeItem('alomran_guest');
  };

  const register = async (phone: string, _password: string, name: string): Promise<boolean> => {
    const newUser: User = {
      id: Date.now().toString(),
      phone,
      name,
      isGuest: false,
    };
    setUser(newUser);
    setIsGuest(false);
    localStorage.setItem('alomran_user', JSON.stringify(newUser));
    return true;
  };

  return (
    <AuthContext.Provider value={{ user, isGuest, login, loginAsGuest, logout, register }}>
      {children}
    </AuthContext.Provider>
  );
};
